import { getItem, storeItem } from "@/lib/browser/storage";
import { PROPERTY_ID_STORAGE_KEY } from "@/lib/hooks/use-properties";
export const storePropertyId = (id) => {
  storeItem(PROPERTY_ID_STORAGE_KEY, id);
};

export const getStoredPropertyId = () => {
  return getItem(PROPERTY_ID_STORAGE_KEY);
};
